module.exports = __webpack_public_path__ + "img/iap.d5aa2380.png";